export default __webpack_public_path__ + "static/media/product1.81e58ebc.webp";